import { Divider } from '@qonsoll/react-design'
import styled from 'styled-components'

const StyledDivider = styled(Divider)`
  margin-top: 0px !important;
`

export default StyledDivider
